import { AreaI } from "interfaces/Area";
import { EspacioCurricularI } from "interfaces/EspacioCurricular";
import { TipoEspacioI } from "interfaces/TipoEspacio";
import { infoFetchGetAreaI, makeArea } from "./area";
import { NivelI } from "interfaces/Nivel";
import { CicloI } from "interfaces/Ciclo";

export interface infoFetchEspaciosCurricularesI {
  id: number | string;
  nombre: string;
  descripcion: string;
  sub_tipo: string;
  tipoEspacio: TipoEspacioI;
  area: infoFetchGetAreaI;
  nivel: NivelI;
  anio: number;
  horas_semanales: number;
  cuatrimestre?: number | null;
  espacio_formacion: string;
  ciclo: CicloI;
}

class EspacioCurricular implements EspacioCurricularI {
  id: number | string;
  nombre: string;
  descripcion: string;
  sub_tipo: string;
  tipo_espacio: TipoEspacioI;
  area: AreaI;
  anio: number;
  horas_semanales: number;
  cuatrimestre: number | null;
  espacio_formacion: string;
  nivel: NivelI;
  ciclo: CicloI;

  constructor(dto: infoFetchEspaciosCurricularesI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
    this.descripcion = dto.descripcion;
    this.sub_tipo = dto.sub_tipo;
    this.tipo_espacio = dto.tipoEspacio;
    this.area = makeArea(dto.area);
    this.nivel = dto.nivel;
    this.anio = dto.anio;
    this.horas_semanales = dto.horas_semanales;
    this.cuatrimestre = dto.cuatrimestre ?? null;
    this.espacio_formacion = dto.espacio_formacion;
    this.ciclo = dto.ciclo;
  }
}

export const makeEspacioCurricular = (
  infoFetch: infoFetchEspaciosCurricularesI,
) => {
  return new EspacioCurricular(infoFetch);
};
